export default __webpack_public_path__ + "static/media/speed-losses.21447917.svg";